export enum RoleEnum {
  Admin = 1,
  CustomerAdmin = 2,
  Customer = 3,
  BetaTest = 4
}
